module.exports = "//public.zight.com/packs/media/images/annotate/ellipse-f1ef3414857a204e58b98c9abdd30093.svg";